import React from "react";
import Footer from "../Components/Footer";
import ScrollReveal from "../Components/ScrollReveal";
import { Link } from "react-router-dom";
import Image1 from "../Images/image 1.png";
import Image2 from "../Images/image 2.png";
import Image3 from "../Images/image 3.png";
import Image4 from "../Images/image 4.png";
import Image5 from "../Images/image 5.png";
import Image6 from "../Images/image 6.png";
import "../Styles/BlogPage.css";

const blogPosts = [
  { slug: "benefits-of-stucco-exterior", image: Image1, category: "Stucco", date: "July 15, 2026", title: "5 Benefits of Choosing Stucco for Your Home's Exterior", excerpt: "Discover why stucco remains one of the most popular and durable exterior finish options for homes in Florida and beyond.", readTime: "5 min read" },
  { slug: "when-to-repair-drywall", image: Image2, category: "Drywall", date: "June 28, 2026", title: "Signs Your Drywall Needs Professional Repair", excerpt: "Learn how to identify common drywall problems and when it's time to call in the professionals for repair.", readTime: "4 min read" },
  { slug: "popcorn-ceiling-removal-guide", image: Image3, category: "Renovation", date: "June 10, 2026", title: "The Complete Guide to Popcorn Ceiling Removal", excerpt: "Everything you need to know about removing popcorn ceilings safely and achieving a modern, smooth finish.", readTime: "6 min read" },
  { slug: "choosing-right-paint-finish", image: Image4, category: "Painting", date: "May 22, 2026", title: "How to Choose the Right Paint Finish for Every Room", excerpt: "Flat, eggshell, satin, or semi-gloss? Understanding paint finishes helps you make the best choice.", readTime: "4 min read" },
  { slug: "stucco-maintenance-tips", image: Image5, category: "Maintenance", date: "May 5, 2026", title: "Stucco Maintenance: Tips to Keep Your Exterior Looking New", excerpt: "Simple maintenance practices that extend the life of your stucco and keep your property looking its best.", readTime: "3 min read" },
  { slug: "drywall-vs-plaster", image: Image6, category: "Drywall", date: "April 18, 2026", title: "Drywall vs. Plaster: Which Is Right for Your Project?", excerpt: "Compare the pros and cons of drywall and plaster to determine the best wall solution for your renovation.", readTime: "5 min read" },
];

function BlogPage() {
  const featured = blogPosts[0];
  const rest = blogPosts.slice(1);

  return (
    <div className="blog-page">
      <section className="inner-hero">
        <div className="inner-hero-bg"><img src={Image1} alt="" className="inner-hero-img" /></div>
        <div className="inner-hero-overlay"></div>
        <div className="inner-hero-content">
          <span className="section-label">OUR BLOG</span>
          <h1>Tips, Guides & Insights</h1>
          <p>Expert advice on stucco, drywall, painting and home improvement</p>
          <div className="inner-hero-breadcrumb"><Link to="/">Home</Link> <span>/</span> Blog</div>
        </div>
      </section>

      <ScrollReveal>
        <section className="blog-featured">
          <div className="blog-featured-inner">
            <Link to={`/blog/${featured.slug}`} className="blog-featured-card">
              <div className="blog-featured-image"><img src={featured.image} alt={featured.title} /><div className="blog-featured-category">{featured.category}</div></div>
              <div className="blog-featured-content">
                <div className="blog-meta"><span>{featured.date}</span><span className="blog-meta-dot">•</span><span>{featured.readTime}</span></div>
                <h2>{featured.title}</h2>
                <p>{featured.excerpt}</p>
                <span className="blog-read-more">Read Article →</span>
              </div>
            </Link>
          </div>
        </section>
      </ScrollReveal>

      <ScrollReveal>
        <section className="blog-grid-section">
          <div className="blog-grid-inner">
            <div className="blog-grid">
              {rest.map((post) => (
                <Link to={`/blog/${post.slug}`} className="blog-card" key={post.slug}>
                  <div className="blog-card-image"><img src={post.image} alt={post.title} /><div className="blog-card-category">{post.category}</div></div>
                  <div className="blog-card-content">
                    <div className="blog-meta"><span>{post.date}</span><span className="blog-meta-dot">•</span><span>{post.readTime}</span></div>
                    <h3>{post.title}</h3>
                    <p>{post.excerpt}</p>
                  </div>
                </Link>
              ))}
            </div>
          </div>
        </section>
      </ScrollReveal>

      <Footer />
    </div>
  );
}

export default BlogPage;
